export { default } from './PaymentIcon';



// WEBPACK FOOTER //
// ./src/client/js/view/components/PaymentIcons/PaymentIcon/index.js